let vm;

export function initLive() {
  vm.setConfig(config.aovivo_variancia, config.aovivo_taxamaxima, config.aovivo_taxaminima);
  vm.init();
}
$(function () {
  Vue.filter('display', function (seconds) {
    let format = function (val) { return `0${Math.floor(val)}`.slice(-2); }
    let minutes = seconds / 60;
    return [minutes, seconds % 60].map(format).join(':')
  });
  Vue.component('timer', {
    props: ['game'],
    template: `<div class="time">
      <span>{{
        game.inplay
          ? formatSeconds(game.passed_seconds)
          : getStatus(game.status)
      }}</span>
      </div>`,
    data: function () {
      return {
        offset: 0,
        interval: 0
      }
    },
    computed: {
      seconds: function () {
        return this.time.minute;
      },
    },
    watch: {
      time: function () {
        this.offset = 0;
        if (this.inplay) {
          this.ticTac();
        } else {
          clearInterval(this.interval);
        }
      },
    },
    methods: {
      ticTac: function () {
        if (!this.interval) {
          const vue = this;
          vue.interval = setInterval(function () {
            vue.offset += 1
          }, 1000)
        }
      },
      getStatus(status) {
        switch (status) {
          case "NS":
            return "Aguardando inicio";
          case "HT":
            return "Intervalo";
        }
      },
      formatSeconds: function (seconds) {
        let format = function (val) { return `0${Math.floor(val)}`.slice(-2); }
        let minutes = seconds / 60;
        return [minutes, seconds % 60].map(format).join(':')
      }
    },
    created: function () {
      if (this.inplay) {
        this.ticTac();
      }
    }
  });
  Vue.component('bmais', {
    template: `<div class="modalWindowLive" :class="isshown?'show':'hide'">
    <table border='0' cellpadding='2' cellspacing='2' width='100%' style='font-size: Normal;'>
    <tr id='header' style='color: #fff;'><td style='min-width:300px;'>Descrição</td><td>Taxa</td></tr>
    <!-- <template v-if="game && game.inplayOdds">
      <template v-for="grupo in game.inplayOdds.data">
        <tr :key="grupo.market_id" class='subtitulotabela'><td colspan='2'>{{ grupo.market }}</td></tr>
        <tr :class="(i%2)?'tabelaLinhaPar2':'tabelaLinhaImpar2'" v-for="(odd, i) in grupo.values" :key="odd.bm_fixture_id">
          <td style='min-width:300px;' >{{ odd.info }}</td>
          <a href='#' :disabled="odd.value <= 1 || odd.suspend"
            @click.prevent="
              moreOptionsClose(
                moreOptionsSelected,
                odd.odd_id,
                odd.id,
                odd.taxa,
                odd.odds
              )">
          {{ odd.value }}
          </a>
        </tr>
      </template>
    </template> -->
    </table>
    </div>`,
    props: ['game', 'isshown']
  })
  Vue.component('bback', {
    template: `<div class="modalBack" :class="isshown?'show':'hide'" @click="hide"></div>`,
    props: ['isshown'],
    methods:{
      hide: function(){
        vm.$data.maisShown = false;
      }
    }
  })
  Vue.component('bgame', {
    props: ['game', 'conf'],
    template: `
    <tr class="tabelaLinhaImpar2">
      <td style="width: 100%;"><b>{{game.info.home.name}}</b> x <b>{{game.info.away.name}}</b><br>{{game.info.time}}</td>
      <td width="40px" align="center"><b><timer :game="game"></timer></b></td>
      <td width="40px" align="center"><b>{{ game.info.ss }}</b></td>
      <td width="40px" align="center"><b><a href="#" :class="[tendenciaCasa, fcasa?'flash':'']" @click.prevent="addOdd(game,'1')">{{getMain('1')}}</a></b></td>
      <td width="40px" align="center"><b><a href="#" :class="[tendenciaEmpate, fempate?'flash':'']" @click.prevent="addOdd(game,'X')">{{getMain('X')}}</a></b></td>
      <td width="40px" align="center"><b><a href="#" :class="[tendenciaFora, ffora?'flash':'']" @click.prevent="addOdd(game,'2')">{{getMain('2')}}</a></b></td>
      <td width="40px" align="center"><b><a href="#" @click.prevent="moreOptions(game)" >+{{ game.info.mais_jogos }}</a></b></td>
    </tr>`,
    data: function () {
      return {
        tcasa: 0,
        tempate: 0,
        tfora: 0,
        fcasa: false,
        fempate: false,
        ffora: false
      }
    },
    computed: {
      tendenciaCasa: function () {
        if (this.tcasa > 0) {
          return 'tup'
        } else if (this.tcasa < 0) {
          return 'tdown'
        } else {
          return ''
        }
      },
      tendenciaEmpate: function () {
        if (this.tempate > 0) {
          return 'tup'
        } else if (this.tempate < 0) {
          return 'tdown'
        } else {
          return ''
        }
      },
      tendenciaFora: function () {
        if (this.tfora > 0) {
          return 'tup'
        } else if (this.tfora < 0) {
          return 'tdown'
        } else {
          return ''
        }
      },
    },
    watch: {
      'game.ft.casa': function (novo, velho) {
        this.tendencia('casa', novo, velho);
      },
      'game.ft.empate': function (novo, velho) {
        this.tendencia('empate', novo, velho);
      },
      'game.ft.fora': function (novo, velho) {
        this.tendencia('fora', novo, velho);
      }
    },
    methods: {
      // Cor fica até a odd mudar de novo; o flash marca o instante da mudança.
      tendencia: function (sel, novo, velho) {
        const n = parseFloat(novo) || 0;
        const v = parseFloat(velho) || 0;
        if (!n || !v || n === v) {
          return;
        }
        this['t' + sel] = n > v ? 1 : -1;
        this['f' + sel] = true;
        setTimeout(() => { this['f' + sel] = false; }, 500);
      },
      calculateOdd: function (odd) {
        let taxa = parseFloat(odd);
        taxa = taxa * (100 + this.conf.variancia) / 100;
        if (taxa <= 1) {
          return "-";
        }
        return Math.min(taxa, this.conf.taxamaxima).toFixed(2);
      },
      getMain(odd) {
        let sel;
        switch (odd) {
          case '1':
            sel = this.game.ft.casa || 0;
            break;
          case 'X':
            sel = this.game.ft.empate || 0;
            break;
          case '2':
            sel = this.game.ft.fora || 0;
            break;
        }

        if (sel) {
          return this.calculateOdd(sel);
        } else {
          return "-"
        }
      },
      addOdd: function (game, odd) {
        window.ConsultarOddLocalLive(game, odd);
      },
      moreOptions: function (game) {
        window.MaisOdds(game.info.id, 1, game)
      }
    },
    created: function () {
      if (this.inplay) {
        this.ticTac();
      }
    }
  });
  vm = new Vue({
    el: "#grdJogosLive",
    data: {
      gameList: [],
      interval: 0,
      emptyOnce: false,
      maisShown: false,
      selGame: null,
      conf: {
        variancia: 0,
        taxamaxima: 0,
        taxaminima: 0
      }
    },
    watch:{
      maisShown:function(val){
        if(val){
          $('body').addClass('noscroll');
        }else{
          $('body').removeClass('noscroll');
        }
      }
    },
    methods: {
      formatDate: function (epoch) {
        return moment.unix(epoch).format('dddd, MMMM Do, YYYY h:mm:ss A')
      },
      processDetail: function (newGame) {
        var oldGame = this.gameList.findIndex(function (i) {
          return i.info.id == newGame.info.id
        })
        //oldGame = newGame
        this.$set(this.gameList, oldGame, newGame);
      },
      setGameList: function (list) {
        this.gameList = list;
      },
      setConfig: function (variancia, taxamaxima, taxaminima) {
        this.conf.variancia = variancia;
        this.conf.taxamaxima = taxamaxima;
        this.conf.taxaminima = taxaminima;
      },
      moreOptions: function (game) {
        this.maisShown = true;
        this.selGame = game;
        //$('body').addClass('noscroll');
      },
      getGameList() {
        axios.get('/enet/CampJogosLive')
          .then(response => {
            const list = response.data && response.data.data;
            if (!Array.isArray(list)) {
              return;
            }
            // Falha no feed volta lista vazia; só esvazia a grade se vier vazia duas vezes seguidas.
            if (!list.length && this.gameList.length && !this.emptyOnce) {
              this.emptyOnce = true;
              return;
            }
            this.emptyOnce = false;
            this.setGameList(list);
            window.AtualizarCabecalhoLive(list);
          })
          .catch(error => {
            console.log(error);
          })
      },
      init: function () {
        clearInterval(this.interval);
        this.getGameList();
        this.interval = setInterval(this.getGameList, 3000);
      }
    },
  });
});
